import {
  Drawer,
  Typography,
  Box,
  LinearProgress,
  IconButton,
  Toolbar,
} from "@mui/material";
import React, { useCallback, useEffect } from "react";
import AgricultureAppRoutes from "../../Routes/AgricultureAppRoutes";
import SidebarCollapse from "./SidebarCollapse";
import SidebarItem from "./SidebarItem";
import Grid from "@mui/material/Grid2";
import {
  MasterDataContextType,
  useMasterData,
} from "../../ContextAPI/MasterContext";
import CloseIcon from "@mui/icons-material/Close";
import { useWasteManagement } from "../../ContextAPI/WasteManagementContext";
import { RouteType } from "../../Routes/Routesconfig";
import InfraStructureAppRoutes from "../../Routes/InfraStructureAppRoutes";
import WasteManagementAppRoutes from "../../Routes/WasteManagementAppRoutes";
import RetailAppRoutes from "../../Routes/RetailAppRoutes";
import SenszLogo from "../../Assests/SVG/Sensz_Logo_New.svg";
import { t } from "i18next";
import { AppRoutes } from "../../Routes/Layout/Routes";
import { useLocation } from "react-router-dom";

const SideBarLayout = () => {
  const location = useLocation();
  const { masterState, dispatchMaster } = useMasterData();

  var currentAppRoutes: RouteType[] = [
    ...AgricultureAppRoutes,
    ...InfraStructureAppRoutes,
    ...WasteManagementAppRoutes,
    ...RetailAppRoutes,
  ].filter((x) => x.routeName === masterState.activeTab);

  // Example data for total devices, active, and inactive

  const handleInputChange = useCallback(
    (field: keyof MasterDataContextType, value: string | number) => {
      dispatchMaster({ type: "SET_FIELD", field, value });
    },
    [dispatchMaster]
  );

  const { totalDevices, activeDevices, inactiveDevices } = masterState;

  const handleCloseSidebar = () => {
    dispatchMaster({ type: "SET_FIELD", field: "sidebaropen", value: false });
  };

  // useEffect(() => {
  //   if (location.pathname.includes(AppRoutes.DASHBOARDINSIGHTS)) {
  //     masterState.sidebaropen;  // Close the sidebar if on DASHBOARDINSIGHTS
  //   } else {
  //     masterState.sidebaropen;  // Keep the sidebar state as per masterState
  //   }
  // }, [location.pathname, masterState.sidebaropen, AppRoutes.DASHBOARDINSIGHTS]);

  return (
    <Drawer
      variant="permanent"
      open={masterState.sidebaropen}
      onClose={handleCloseSidebar}
      className="scrollable-section"
      sx={{
        width: masterState.sidebaropen ? "18vw" : 0,
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",

        "& .MuiDrawer-paper": {
          width: masterState.sidebaropen ? "18vw" : 0,
          boxSizing: "border-box",
          background: "#16325B",
          color: "#fff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          overflowY: "auto",
        },
      }}
    >
      {/* Sidebar Route Items */}
      {/* <Toolbar /> */}
      <Grid sx={{ mt: 14 }}>
        {currentAppRoutes.map((route, index) =>
          route.sidebarProps ? (
            route.child ? (
              <SidebarCollapse
                item={route}
                isFirstParent={index === 0}
                key={index}
              />
            ) : (
              <SidebarItem item={route} key={index} />
            )
          ) : null
        )}
      </Grid>
      {/* Device Monitoring Section at the Bottom */}
    </Drawer>
  );
};

export default SideBarLayout;
